import cookies from 'browser-cookies';
import { forgeRevalidationCookie } from '@innovyze/stylovyze/lib/types/authenticationContext.types';
export const checkForTokenExpiration = (setTimer, setNeedTimerSet) => {
    const expirationDate = cookies.get(forgeRevalidationCookie);
    if (expirationDate) {
        const date = new Date(expirationDate);
        if (date) {
            const difference = date.getTime() - new Date().getTime();
            if (difference > 0) {
                setTimer(difference);
                setNeedTimerSet(true);
            }
        }
    }
};
